import styled from 'styled-components'

const Wrapper = styled.main`

`
export default Wrapper
